import { render, staticRenderFns } from "./TableFooterSumaTotales.vue?vue&type=template&id=16a23b56&"
import script from "./TableFooterSumaTotales.vue?vue&type=script&lang=js&"
export * from "./TableFooterSumaTotales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports